import PropTypes from 'prop-types';
import { StatisticsLayout } from 'views/components';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Card,
    Container,
    FormGroup,
    Input,
    LineChart,
    Table
} from 'mol-ui';
import {
    HEADERS,
    downloadHeaders
} from './fixtures';
import React, { useMemo } from 'react';
import {
    clearObject,
    isLocked
} from 'shared/utils';
import {
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const AbsenceRate = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        loading,
        absenceRate,
        absenceRateMonthly
    } = useSelector('statistics');
    const [workplaceInput, workplace] = useInput('');

    const filteredAbsenceRate = useMemo(() => {
        if (!workplace) return absenceRate;
        return absenceRate.filter(({ workplace_name }) => workplace_name.toLowerCase().indexOf(workplace.toLowerCase()) >= 0);
    }, [absenceRate, workplace]);

    const onFiltersChange = filters => {
        const { date: { month, year } = {} } = filters ?? {};
        dispatch(statisticsActions.getStatisticsAbsenceRate(clearObject({
            ...filters,
            month: (month ?? moment().month() + 1).toString().padStart(2, '0'),
            year: year ?? moment().year()
        })));
    };

    const downloadController = {
        data: absenceRate,
        downloading: loading,
        fileName: t('Tasa de ausentismo'),
        headers: downloadHeaders,
        manual: false
    };

    const lineConfig = useMemo(() => {
        if (!absenceRateMonthly?.years) return [];
        return absenceRateMonthly?.years.map(year => ({
            dataKey: `absence_rate_${ year }`,
            label: year
        }));
    }, [absenceRateMonthly]);

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterDates={ false }
            filterPatients={ ['date'] }
            filterProfessionals={ false }
            filterSpecialties={ false }
            loading={ loading }
            tabController={ tabController }
            onFiltersChange={ onFiltersChange }
        >
            {
                (!isEmpty(absenceRate) || !isEmpty(absenceRateMonthly?.data)) &&
                <Container padding="8px">
                    <Card margin="10px 0px 0px 0px" overflowX="auto" padding="10px">
                        <LineChart
                            legend
                            completeTooltip={ false }
                            config={ lineConfig }
                            data={ absenceRateMonthly?.data }
                            disabled={ loading }
                        />
                    </Card>
                    <FormGroup label={ `${ t('Buscar lugar de trabajo') }...` } margin="20px 0px 0px 0px">
                        <Input { ...workplaceInput } />
                    </FormGroup>
                    <Table
                        config={ HEADERS }
                        data={ filteredAbsenceRate }
                        margin="0px"
                        maxHeight="400px"
                    />
                </Container>
            }
        </StatisticsLayout>
    );
};

AbsenceRate.propTypes = {
    tabController: PropTypes.object
};

export default AbsenceRate;
